@if (isLoading()) {
  <aw-loading-animation></aw-loading-animation>
}
@if (!isLoading()) {
  <div class="flex flex-col gap-6 md:flex-row">
    <div class="flex w-full flex-col md:w-2/3">
      <router-outlet></router-outlet>
    </div>
    <aw-subscription-ticket-shopping-cart
      class="fixed bottom-0 left-0 z-20 w-full md:relative md:w-1/3"
      [attr.data-testid]="'ticket-option-configuration-page-shopping-cart'"
      (onButtonClick)="proceedToNextStep()"
      [page]="EPage.Configuration"></aw-subscription-ticket-shopping-cart>
  </div>
}
